const theme = {
  colors: {
    // Grayscale palette
    black: '#000000',
    darkGray: '#212121',
    gray: '#616161',
    mediumGray: '#9E9E9E',
    lightGray: '#E0E0E0',
    offWhite: '#F5F5F5',
    white: '#FFFFFF',
    
    // Accent colors (minimal use as specified)
    accent: '#3D5AFE', // Blue accent
    accentHover: '#536DFE',
    success: '#00C853',
    error: '#FF3D00',
  },
  
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', sans-serif",
    secondary: "'SF Pro Display', 'Roboto', sans-serif",
    code: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
  },
  
  fontSizes: {
    small: '0.875rem',
    medium: '1rem',
    large: '1.25rem',
    xlarge: '1.5rem',
    xxlarge: '2rem',
    xxxlarge: '3rem',
    hero: '4rem',
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '4rem',
    xxl: '8rem',
  },
  
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
  
  transitions: {
    short: '0.2s ease-in-out',
    medium: '0.3s ease-in-out',
    long: '0.5s ease-in-out',
  },
  
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    circular: '50%',
  },
};

export default theme; 